<template>
  <div id="start">
    <v-navigation-drawer v-model="sidebar" temporary app>
      <v-list>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          @click="
            scrollToPart(item.path);
            sidebar = false;
          "
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-bind:class="{ toolbar: $vuetify.breakpoint.mobile }"
      :elevation="bg_elevation"
      :fixed="!$vuetify.breakpoint.mobile"
      :color="bg"
    >
      <span class="hidden-xs-only" v-show="title_show">
        <v-img
          class="mx-2"
          src="../assets/penguin_logo.svg"
          max-height="40"
          max-width="40"
          contain
        ></v-img>
      </span>
      <span class="hidden-xs-only" v-show="title_show">
        <a @click="scrollToPart('start')">
          <v-app-bar-title :class="title_color">
            Aleksandar Todorov
          </v-app-bar-title>
        </a>
      </span>
      <v-spacer></v-spacer>

      <span class="hidden-sm-and-up">
        <v-app-bar-nav-icon
          class="white--text"
          @click="sidebar = !sidebar"
        ></v-app-bar-nav-icon>
      </span>

      <span class="hidden-xs-only">
        <v-btn
          v-for="i in menuItems"
          :key="i.title"
          :to="i.to"
          outlined
          elevation="3"
          large
          :color="button_color"
          class="ml-5"
          @click="scrollToPart(i.path)"
        >
          {{ i.title }}
        </v-btn>
      </span>
    </v-app-bar>

    <!-- Particles js -->
    <div id="particles-js" class="main-image" />

    <div class="main-text">
      <v-container fill-height>
        <v-row>
          <v-col cols="12">
            <p class="white--text text-lg-h3 text-md-h4 text-sm-h5 text-h6">
              Hello, my name is
              <strong class="secondary--text">Aleksandar.</strong><br />I’m a
              <span class="secondary--text">software developer</span>
            </p>
          </v-col>
          <v-col md="6" lg="4" sm="6" cols="6">
            <v-btn
              block
              class="mt-10"
              @click="scrollToPart('experience')"
              outlined
              x-large
              color="white"
            >
              View my work
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import "particles.js";
import particlesJson from "../assets/particles.json";
export default {
  data() {
    return {
      title_show: false,
      title_color: "primary--text",
      button_color: "white",
      sidebar: false,
      bg: "transparent",
      bg_elevation: 0,
      menuItems: [
        { title: "About", path: "about" },
        { title: "Work", path: "experience" },
        { title: "Projects", path: "projects" },
        { title: "Contact", path: "contact" },
      ],
    };
  },
  mounted() {
    window.onscroll = () => {
      this.changeColor();
    };
    this.initParticles();
  },
  methods: {
    initParticles() {
      window.particlesJS("particles-js", particlesJson);
    },
    changeColor() {
      if (window.pageYOffset > window.innerHeight * 0.5) {
        this.bg = "white";
        this.bg_elevation = 3;
        this.button_color = "black";
        this.title_color = "black--text";
        this.title_show = true;
      } else {
        this.bg = "transparent";
        this.bg_elevation = 0;
        this.button_color = "white";
        this.title_color = "white--text";
        this.title_show = false;
      }
    },
    scrollToPart(to) {
      const myEl = document.getElementById(`${to}`);

      this.$smoothScroll({
        scrollTo: myEl,
        offset: -50,
        updateHistory: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
%container-position {
  min-height: 300px;
  height: 50vh;
}

.main-image {
  @extend %container-position;
  background-image: url("../assets/main_background.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
}

.main-text {
  @extend %container-position;

  position: absolute;
  top: 0;
  right: 0;
  left: 0;

  background-color: rgba(0, 0, 0, 0.7);
}

.toolbar {
  right: 0;
  position: absolute;
  z-index: 5;
}
</style>